import { createRouter, createWebHistory } from 'vue-router'
import ACMG from '../views/ACMG.vue'

const routes = [
  {
    path: '/',
    redirect: '/acmg'
  },
  {
    path: '/acmg',
    name: 'ACMG',
    component: ACMG
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
